import { useEffect } from 'react';
import { PageContainer, Tile } from 'components/Layout/PageContainer';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import { TopReturnedProductsInfoContent } from './TopReturnedProductsInfoContent';
import { TopReturnedProductsTable } from 'pages/insights-pro/product-tab/reports/top-returned-products/TopReturnedProductsTable';

export function TopReturnedProducts() {
  const { setContent } = useInfoDrawer();

  useEffect(() => {
    setContent({
      titleKey: 'insights.product.reports.returns',
      subtitleKey: 'info.content.all_dates_utc',
      content: <TopReturnedProductsInfoContent />,
    });

    return () => {
      setContent(null);
    };
  }, [setContent]);

  return (
    <PageContainer>
      <Tile className="text-lg p-4" titleId="insights.product.reports.returns" />
      <TopReturnedProductsTable />
    </PageContainer>
  );
}
